import { model, Model } from 'mst-collection';
import { types } from 'mobx-state-tree';

import { formatPlayerTimeFromMs } from '@utils';

export class TutorialTimestamp extends Model({
  time: types.number,
  text: types.string,
}) {
  get formattedTime() {
    return formatPlayerTimeFromMs(this.time);
  }
}

export const TutorialTimestampModel = model(TutorialTimestamp);
